import React from "react";
import Chart from "react-apexcharts";

const ChartColumn = ({
  categories = [],
  data = [],
  name = "Stats",
  titlex = "Date",
  titley = "Chiffres",
  showLabels = true,
}) => {
  const options = {
    chart: {
      type: "bar",
      height: "100%",
      dropShadow: {
        enabled: true,
      },
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
        borderRadius: 10,
        borderRadiusApplication: "end",
        borderRadiusWhenStacked: "last",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      title: {
        text: titlex,
      },
      categories: categories,
      labels: {
        show: showLabels, // Afficher les libellés sur l'axe X
      },
    },
    yaxis: {
      show: true,
      title: {
        text: titley,
      },
    },
    fill: {
      opacity: 1,
      colors: ["#f97316"], // Couleur des barres
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val; // Formatage du tooltip
        },
      },
    },
  };

  const series = [
    {
      name: name, // Nom de la série de données
      data: data, // Les valeurs des barres
    },
  ];

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      height="100%"
      width="100%"
      className="h-full w-full"
    />
  );
};

export default ChartColumn;
